import React, { useEffect } from 'react';
import { Title, ButtonsGroup, Button } from 'components/commons';
import useRouter from 'use-react-router';

import './pre-qualified-not-found.scss';
import { useProfile } from 'providers/profile.provider';
import coneIcon from 'assets/svg/cone.svg';

const PreQualifiedNotFound: React.FC = () => {
    const { history } = useRouter();
    const { setIsPartner } = useProfile();

    useEffect(() => {
        setIsPartner(true);
    }, []);

    const goToDirect = () => {
        setIsPartner(false);
        history.push('/?utm_source=landing&utm_campain=ambev')
    }

    return (
        <div className="message-box-container pre-qualified-message-box-container">
            <div className="inner">
                <div className="screen">
                    <div className="message-box pre-qualified-not-found">

                        <img className="icon" src={coneIcon} />

                        <Title>
                            não encontramos uma pré-aprovação
                        </Title>

                        <p className="text">
                            Você informou um CNPJ que não possui um crédito pré-aprovado na parceria Biz com Ambev.
                        </p>

                        <p className="text">
                            Que tal tentar um empréstimo com a Biz?
                        </p>

                        <ButtonsGroup align="left" className="btn-group">
                            <Button label="voltar" onClick={() => history.goBack()}  variant="secondary"/>
                            <Button label="pede biz, vai" onClick={goToDirect} />
                        </ButtonsGroup>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default PreQualifiedNotFound;
